import { render, staticRenderFns } from "./EditPermissionGroup.vue?vue&type=template&id=5b076a1a&scoped=true"
import script from "./EditPermissionGroup.vue?vue&type=script&lang=js"
export * from "./EditPermissionGroup.vue?vue&type=script&lang=js"
import style0 from "./EditPermissionGroup.vue?vue&type=style&index=0&id=5b076a1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b076a1a",
  null
  
)

export default component.exports